





































































import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import Base64 from "@/utils/Base64";
import api from "@/api";
import {
  ProvinceDto,
  CityDto,
  AreaDto,
  TownDto,
  AttachmentHostType,
} from "@/api/appService";

export interface ProvinceCityAreaTownDto {
  /**  */
  provinceId?: undefined;

  /**  */
  cityId?: undefined;

  /**  */
  areaId?: undefined;

}

@Component({
  name: "provinceCityAreaEdit",
})
export default class ProvinceCityAreaEdit extends Vue {
  // @Model("change", { type: Array, default: [] }) readonly fileIds!: number[];

  @Prop({ required: false })
  province!: undefined;

  @Prop({ required: false })
  city!: undefined;

  @Prop({ required: false })
  area!: undefined;

  @Prop() dataId?: number;

  form?: ProvinceCityAreaTownDto = {};

  provinceList?: ProvinceDto[] = [];
  cityList?: CityDto[] = [];
  areaList?: AreaDto[] = [];

  textValue=""

  created() {
    this.init();
  }

  @Watch("province")
  changeProvince(val: number | undefined) {
    if (!val) {
      this.form!.provinceId = undefined;
      this.form!.cityId = undefined;
      this.form!.areaId = undefined;
      this.provinceList = [];
      this.cityList = [];
      this.areaList = [];
      api.province.getAllList().then((res: any) => {
        this.provinceList = res!;
      });
    }
  }
  @Watch("province")
  init() {
    this.form!.provinceId = this.province == 0 ? undefined : this.province;
    this.form!.cityId = this.city == 0 ? undefined : this.city;
    this.form!.areaId = this.area == 0 ? undefined : this.area;
    console.log(this.form)
    this.updateData();
    if (!this.provinceList || this.provinceList.length === 0) {
      api.province.getAllList().then((res: any) => {
        this.provinceList = res!;
      });
    }

    // if (this.dataId ?? 0 > 0) {
    if (this.form!.provinceId) {
      this.showCityList(true);
    }

    if (this.form!.cityId) {
      this.showAreaList(true);
    }
    //
    // if (this.form!.areaId) {
    //   this.showTownList(true);
    // }
    // }
  }

  showCityList(isInit: boolean) {
    if (!isInit) {
      this.$set(this.form!, "cityId", "");
      this.$set(this.form!, "areaId", "");
      this.$set(this.form!, "townId", "");
      //
      this.setTextValue()
      this.updateData();
    }

    api.city
      .getAllList({ provinceId: this.form!.provinceId })
      .then((res: any) => {
        this.cityList = res!;
      });
  }

  showAreaList(isInit: boolean) {
    if (!isInit) {
      this.$set(this.form!, "areaId", "");
      this.$set(this.form!, "townId", "");
      //
      this.setTextValue()
      this.updateData();
    }

    api.area.getAllList({ cityId: this.form!.cityId }).then((res: any) => {
      this.areaList = res!;
    });
  }
  setAreaValue(isInit: boolean) {
    if (!isInit) {
      this.updateData();
    }
    api.area.getAllList({ cityId: this.form!.cityId }).then((res: any) => {
      this.areaList = res!;
    });
  }

  // showTownList(isInit: boolean) {
  //   if (!isInit) {
  //     this.$set(this.form!, "townId", "");
  //     //
  //     this.updateData();
  //   }
  //
  //   api.town.getAllList({ areaId: this.form!.areaId }).then((res: any) => {
  //     this.townList = res!;
  //   });
  // }
  //
  // setTownValue(isInit: boolean) {
  //   if (!isInit) {
  //     this.updateData();
  //   }
  //   api.town.getAllList({ areaId: this.form!.areaId }).then((res: any) => {
  //     this.townList = res!;
  //   });
  // }

  updateData() {

    this.$emit("update:province", this.form!.provinceId);
    this.$emit("update:city", this.form!.cityId);
    this.$emit("update:area", this.form!.areaId);
    if (this.textValue){
      this.$emit("setAddress",this.textValue);
    }
  }

  setTextValue(){
    if (this.form&&this.form.provinceId){
      const provice=this.provinceList!.find(d=>d.id==this.form!.provinceId)
      console.log("provice",provice)
      this.textValue=provice!.provinceName as any;
      console.log("textValue",this.textValue)
    }
    if (this.form&&this.form.cityId){
      const city=this.cityList!.find(d=>d.id==this.form!.cityId)
      this.textValue+=city!.cityName as any;
    }
    if (this.form&&this.form.areaId){
      const area=this.areaList!.find(d=>d.id==this.form!.areaId)
      this.textValue+=area!.areaName as any;
    }
  }
}
